import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { translate } from "@sequentech/ui-core";
import { theme } from "@sequentech/ui-essentials";
import { ESlateCoverageLabel, getSlateCoverageLabel } from "../../services/SlateCoverage";
/**
 * What a slate covers: whether it is a full slate and how many candidates it
 * has in how many offices.
 */
export var SlateCoverageLine = function (_a) {
    var _b;
    var coverage = _a.coverage, contests = _a.contests;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var _d = getSlateCoverageLabel(coverage, contests), label = _d.label, contest = _d.contest;
    var kind = label === ESlateCoverageLabel.FULL
        ? t("slates.coverage.full")
        : label === ESlateCoverageLabel.SINGLE_CONTEST && contest
            ? t("slates.coverage.singleContest", {
                contest: (_b = translate(contest, "name", i18n.language)) !== null && _b !== void 0 ? _b : "",
            })
            : t("slates.coverage.partial");
    return (_jsxs(Box, { className: "slate-coverage", "data-coverage": coverage.kind, children: [_jsx(Typography, { className: "slate-coverage-kind", component: "span", fontSize: "0.875rem", fontWeight: "bold", children: kind }), _jsxs(Typography, { className: "slate-coverage-count", component: "span", fontSize: "0.875rem", color: theme.palette.customGrey.dark, children: [" · ", t("slates.coverage.candidates", { count: coverage.members }), " · ", t("slates.coverage.offices", { count: coverage.covered.length })] })] }));
};
